"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heart = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Heart = function Heart() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.484A7.632 7.632 0 0117.4 1 6.6 6.6 0 0124 7.6c0 4.316-4.797 9.045-7.674 11.882-.26.255-.503.495-.726.718l-2.736 2.736a.9.9 0 01-.636.264h-.456a.9.9 0 01-.636-.264L8.4 20.2c-.223-.223-.466-.463-.726-.718C4.797 16.645 0 11.916 0 7.6A6.6 6.6 0 016.6 1c2.062.064 4.01.96 5.4 2.484zm0 16.92l2.64-2.604c2.436-2.4 6.96-6.888 6.96-10.2a4.2 4.2 0 00-4.236-4.2 6.132 6.132 0 00-4.572 2.76.612.612 0 01-.48.24h-.54a.924.924 0 01-.72-.348A6 6 0 006.6 3.4a4.2 4.2 0 00-4.2 4.2c0 3.312 4.524 7.8 6.96 10.2L12 20.404z",
    clipRule: "evenodd"
  });
};

exports.Heart = Heart;